import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { H_CAMPAIGN_PIEZO_DASHBOARD } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import DashboardCampaign from '../../../campaign/components/campaignDashboard/DashboardCampaign'
import ProgressCard from '../../../components/card/ProgressCard'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { useParams } from 'react-router'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'

const PiezometryCampaignDashboard = () => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)

    const {
        piezometers,
        piezometersAccessibilities,
    } = useSelector(store => ({
        piezometers: store.PiezometryReducer.piezometersLight,
        piezometersAccessibilities: store.PiezometryReducer.piezometersAccessibilities,
    }), shallowEqual)

    const dispatch = useDispatch()
    const { id } = useParams()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_PIEZO_DASHBOARD)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(CampaignAction.loadPiezometryCampaignDashboard(id, p => setProgress(p)))
            .then(() =>setDataLoaded(true))
        if (id !== 'new') {
            dispatch(CampaignAction.fetchPiezometryCampaignEvent(id))
        }
    }, [id, dispatch])

    if (dataLoaded) {
        return (
            <DashboardCampaign
                accessibilities={piezometersAccessibilities}
                stations={piezometers}
                stationType={STATION_TYPE_NAME.piezometry}
            />
        )
    }
    return <ProgressCard progress={ progress }/>
}

export default PiezometryCampaignDashboard
